module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showSizer || _vm.showElevator) ? _c('div', {
    class: _vm.optsClasses
  }, [(_vm.showSizer) ? _c('div', {
    class: _vm.sizerClasses
  }, [_c('i-select', {
    attrs: {
      "size": _vm.size,
      "placement": _vm.placement
    },
    on: {
      "on-change": _vm.changeSize
    },
    model: {
      value: (_vm.currentPageSize),
      callback: function($$v) {
        _vm.currentPageSize = $$v
      },
      expression: "currentPageSize"
    }
  }, _vm._l((_vm.pageSizeOpts), function(item) {
    return _c('i-option', {
      key: item,
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item) + " " + _vm._s(_vm.t('i.page.page')))])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.showElevator) ? _c('div', {
    class: _vm.ElevatorClasses
  }, [_vm._v("\n        " + _vm._s(_vm.t('i.page.goto')) + "\n        "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._current
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.changePage($event)
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.t('i.page.p')) + "\n    ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f1dff5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/page/options.vue
// module id = 661
// module chunks = 1